/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { useState } from 'react';
import styles from '../../styles/components/common/ResetPassword.module.css';
import IOCMImage from '../../../src/assets/images/ICM Logo.png';
import InputField from '../controlVariations/InputField';
import { Cta } from '../controlVariations/Cta';
import { useNavigate } from 'react-router-dom';
import successIcon from '../../assets/images/success.png';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import {
	validatePassword,
	syncPasswordMatchError,
} from '../../utils/validation';

const ResetPassword = () => {
	const navigate = useNavigate();
	const [isResetSuccess, setIsResetSuccess] = useState(false);
	const [password, setPassword] = useState('');
	const [rePassword, setRePassword] = useState('');

	const [passwordError, setPasswordError] = useState('');
	const [rePasswordError, setRePasswordError] = useState('');
	const [apiError, setApiError] = useState<string | null>(null);

	const [searchParams] = useSearchParams();
	const token = searchParams.get('token') || '';

	const { resetPassword, loading } = useAuth();

	const handleResetPassword = async () => {
		setApiError(null); // reset old API error

		const pwdError = validatePassword(password);
		const matchError = syncPasswordMatchError(password, rePassword);

		setPasswordError(pwdError);
		setRePasswordError(matchError);

		if (pwdError || matchError) return;

		if (!token) {
			setApiError('Invalid or expired reset link');
			return;
		}

		try {
			const res = await resetPassword(token, password);

			if (res.success) {
				setIsResetSuccess(true);
			} else {
				setApiError(res.message || 'Failed to reset password');
			}
		} catch (err: any) {
			setApiError(err.message || 'Something went wrong');
		}
	};

	return (
		<div className={styles.ResetPassword}>
			<div className={styles.ResetPasswordChild}>
				<div className={styles.logowrapper}>
					<img
						className={styles.icmLogo1}
						alt="IOCM Logo"
						src={IOCMImage}
					/>
				</div>

				{/* 🔁 SWITCH UI HERE */}
				{!isResetSuccess ? (
					/* ================= RESET FORM ================= */
					<div className={styles.ResetPasswordParent}>
						<div className={styles.head}>
							<div className={styles.ResetPasswordLable}>
								Reset password ?
							</div>
						</div>

						<div className={styles.labelCont}>
							<div className={styles.labelhead}>
								Password should have:
							</div>
							<div className={styles.labelChild}>
								1. Minimum 8 characters
							</div>
							<div className={styles.labelChild}>
								2. Uppercase, lowercase, number & symbol
							</div>
							<div className={styles.labelChild}>
								3. Different from previous 3 passwords
							</div>
						</div>

						<div className={styles.inputFields1}>
							<div className={styles.label}>
								Enter New Password{' '}
								<span className={styles.redAsterisk}>*</span>
							</div>
							<InputField
								type="password"
								placeholder="********"
								value={password}
								onChange={(e: any) => {
									const value = e.target.value;
									setPassword(value);

									const error = validatePassword(value);
									setPasswordError(error);

									// 🔁 re-check match if rePassword already typed
									if (rePassword) {
										setRePasswordError(
											syncPasswordMatchError(
												value,
												rePassword
											)
										);
									}
								}}
							/>

							{passwordError && (
								<div className={styles.errorText}>
									{passwordError}
								</div>
							)}
						</div>

						<div className={styles.inputFields1}>
							<div className={styles.label}>
								Re-enter New Password{' '}
								<span className={styles.redAsterisk}>*</span>
							</div>
							<InputField
								type="password"
								placeholder="********"
								value={rePassword}
								onChange={(e: any) => {
									const value = e.target.value;
									setRePassword(value);

									const error = syncPasswordMatchError(
										password,
										value
									);
									setRePasswordError(error);
								}}
							/>

							{rePasswordError && (
								<div className={styles.errorText}>
									{rePasswordError}
								</div>
							)}
						</div>

						<Cta variant="primary" onClick={handleResetPassword}>
							Reset Password
						</Cta>

						{apiError && (
							<div className={styles.errorTextCenter}>
								{apiError}
							</div>
						)}

						<Cta
							variant="secondary"
							onClick={() => navigate('/forgotpassword')}
						>
							Back
						</Cta>
					</div>
				) : (
					/* ================= SUCCESS STATE ================= */
					<div className={styles.ResetPasswordParent}>
						<div className={styles.successContainer}>
							<div className={styles.iconWrapper}>
								<img
									src={successIcon}
									alt="Success"
									className={styles.successIcon}
								/>
							</div>

							<div className={styles.successTitle}>
								Password Reset
							</div>

							<div className={styles.successSubtitle}>
								Re-login with new password
							</div>

							<Cta
								variant="primary"
								onClick={() => navigate('/login')}
							>
								Login
							</Cta>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default ResetPassword;
